import React, { RefObject } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { EditButton, DeleteButton } from "@refinedev/mui";
import { ModalRef } from "@shared/components";

export const useActivityListColumns = (
  onRefetch: () => void,
  translate: (key: string) => string,
  activityModalRef: RefObject<ModalRef>
): GridColDef[] => {
  return React.useMemo<GridColDef[]>(
    () => [
      {
        field: "name",
        headerName: translate("activity_admin.fields.name"),
        minWidth: 250,
        flex: 1,
      },
      {
        field: "actions",
        headerName: translate("table.actions"),
        align: "center",
        headerAlign: "center",
        minWidth: 120,
        sortable: false,
        display: "flex",
        renderCell: ({ row }) => (
          <>
            <EditButton
              hideText
              onClick={() => activityModalRef.current?.open(row)}
            />

            <DeleteButton
              hideText
              recordItemId={row.id}
              resource="v1/activity_admin"
              hidden={false}
              onSuccess={onRefetch}
            />
          </>
        ),
      },
    ],
    [translate, onRefetch, activityModalRef]
  );
};
